// src/App.js
import React, { useState } from "react";
import Login from "./Login";
import Table from "./Table";
import { auth } from "./firebase";
import { signOut } from "firebase/auth";

function App() {
  const [user, setUser] = useState(null);

  const handleLogout = async () => {
    await signOut(auth);
    setUser(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-red-900 via-purple-500 to-red-900 flex flex-col items-center justify-center">
      {!user ? (
        <Login
          onLogin={setUser}
          onGuest={() => setUser({ uid: "guest", email: "Gast", guest: true })}
        />
      ) : (
        <div className="w-full max-w-7xl bg-white p-8 rounded-xl shadow-lg">
          <img src="/logo_redkorps.jpg" alt="Logo" className="mb-4 w-60" />
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
            Willkommen, {user.email === "Gast" ? "Gast" : user.email}!
          </h2>
          <button
            onClick={handleLogout}
            className="w-full py-3 bg-red-500 text-white font-semibold rounded-lg shadow-md hover:bg-red-600 focus:outline-none mb-6"
          >
            Logout
          </button>
          <Table user={user} />
        </div>
      )}
    </div>
  );
}

export default App;
